<template>
  <div>
    <b-modal
      :title="title"
      size="lg"
      centered
      hide-footer
      header-class="head-modal"
      :no-close-on-backdrop="true"
      v-model="modalShow"
    >
      <tables-page
        :tableData="data"
        :tableFields="tableFields"
      >
        <template #cell(no)="row">
          {{ row.index + 1 }}
        </template>

        <template #cell(payment_at)="row">
          {{ convertRocDate(row.item.payment_at, false) }}
        </template>

        <template #cell(is_dead)="row">
          {{ row.item.is_dead ? '是' : '否' }}
        </template>

        <template #cell(remark)="row">
          <template v-if="!isAutoBill">
             <span class="text-danger" v-if="row.item.status === 0">無未繳帳單</span>
              <span v-else-if="row.item.status === 1">銷帳成功</span>
              <span class="text-danger" v-else-if="row.item.status === 2">金額不相符,{{ row.item.need_pay }}(應付帳款) - {{ row.item.real_pay }}(實際付款) = {{ row.item.need_pay - row.item.real_pay }}元</span>
              <span class="text-danger" v-else-if="row.item.status === 3">重複銷帳</span>
              <span class="text-danger" v-else-if="row.item.status === 4">身故不可銷帳</span>
          </template>

          <template v-else>
            <span class="text-danger" v-if="row.item.status === 0">無未繳帳單</span>
            <span v-else-if="row.item.status === 1">銷帳成功</span>
            <span class="text-danger" v-else-if="row.item.status === 2">金額不相符,{{ row.item.need_pay }}(應付帳款) - {{ row.item.real_pay }}(實際付款) = {{ row.item.need_pay - row.item.real_pay }}元</span>
            <span class="text-danger" v-else-if="row.item.status === 3">重複銷帳</span>
            <span class="text-danger" v-else-if="row.item.status === 4">結存不足</span>
            <span class="text-danger" v-else-if="row.item.status === 5">未申請代繳或用戶號碼錯誤</span>
          </template>
        </template>
      </tables-page>
    </b-modal>
  </div>
</template>

<script>
import TablesPage from "@/components/layouts/TablesPage";
import { convertRocDate } from "@/models/HELPERS/common.js";

export default {
  name: 'BatchRemoveBillModal',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    data: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: false,
      default: '批次銷帳'
    },
    isAutoBill: { // 是否為批次銷自動扣款帳單
      type: Boolean,
      required: false,
      default: false
    },
  },
  components: {
    TablesPage
  },
  data () {
    return {
      table_fields: [
        {
          key: "no",
          label: "No",
        },
        {
          key: "number",
          label: "會員編號",
        },
        {
          key: "payment_amount",
          label: "付款金額",
        },
        {
          key: "payment_source",
          label: "付款方式",
        },
        {
          key: "payment_at",
          label: "付款日期",
        },
        {
          key: "is_dead",
          label: "是否已身故",
        },
        {
          key: "remark",
          label: "備註",
        },
      ],
      table_fields_auto: [
        {
          key: "no",
          label: "No",
        },
        {
          key: "pay_auto_name",
          label: "自動扣款姓名",
        },
        {
          key: "pay_auto_ID_number",
          label: "自動扣款身分證",
        },
        {
          key: "pay_bank_account",
          label: "自動扣款郵局帳號",
        },
        {
          key: "payment_amount",
          label: "付款金額",
        },
        {
          key: "payment_source",
          label: "付款方式",
        },
        {
          key: "payment_at",
          label: "付款日期",
        },
        {
          key: "remark",
          label: "備註",
        },
      ],
      table_data: [],
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
    tableFields() {
      return this.isAutoBill ? this.table_fields_auto : this.table_fields;
    }
  },
  watch: {
    show: {
      handler(newValue, oldValue) {

      },
      immediate: false
    }
  },
  methods: {
    convertRocDate
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/components/modal/BatchRemoveBillModal.vue